import { useEffect, useState } from "react";
import client from "../../utils/client";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Skeleton,
  Text,
  Link,
} from "@chakra-ui/react";

const Top10Videos = () => {
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTop10 = async () => {
      try {
        const response = await client.get("/videos/top10");
        setVideos(response.data);
      } catch (err) {
        setVideos([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTop10();
  }, []);

  return (
    <Box mb={7} w={"100%"} borderRadius="lg" boxShadow="sm" p={4} bg="gray.50">
      <Heading
        fontFamily="Afacad"
        size="md"
        color="green.700"
        mb={3}
        textAlign="center"
        letterSpacing="wide"
      >
        Top 10 Mais Vistos
      </Heading>
      <Skeleton isLoaded={!isLoading}>
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>Título</Th>
              <Th textAlign="right">Views</Th>
            </Tr>
          </Thead>
          <Tbody>
            {videos.length ? (
              videos.map((video, idx) => (
                <Tr key={video.videoId}>
                  <Td>
                    <Text fontWeight="bold" color="green.600">
                      {idx + 1}
                    </Text>
                  </Td>
                  <Td>
                    <Link
                      href={`#/acaolflix/${video.videoId}`}
                      color="green.700"
                      fontWeight="semibold"
                      display="inline-block"
                      maxW={["140px", "220px"]}
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                      title={video.name}
                      _hover={{
                        textDecoration: "underline",
                        color: "blue.500",
                      }}
                    >
                      {video.name}
                    </Link>
                  </Td>
                  <Td textAlign="right">
                    <Text fontSize="sm" color="gray.500">
                      {video.youtubeViews?.toLocaleString() || "-"}
                    </Text>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={3}>
                  <Text color="gray.400" align="center">
                    Nenhum vídeo encontrado.
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </Skeleton>
    </Box>
  );
};

export default Top10Videos;
